'use client';

import {
  Box,
  CardHeader,
  Typography,
  Avatar,
  CardContent,
  CardActions,
  Stack,
} from '@mui/material';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import Image from 'next/image';

import { Or2Card } from '@/components/Surface/Or2Card';

import { Or2LinkButton } from '@/components/button/Or2LinkButton';

import { ThemeRegistry } from '@/components/ThemeRegistry/ThemeRegistry';

import { Or2SupportLink } from '@/components/navigation/Or2SupportLink';

import UnhappyOrtoo from '../public/images/Unhappy-Ortoo.png';

function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          height: '100vh',
          backgroundColor: '#F1F5F8',
        }}
      >
        <ThemeRegistry>
          <Stack justifyContent="center" alignItems="center" height="100vh">
            <Or2Card or2Variant="inner" sx={{ maxWidth: '500px', pb: 2 }}>
              <CardHeader
                title={
                  <Typography variant="h4" component="h1">
                    GovernorHub is having a bad day
                  </Typography>
                }
                avatar={
                  <Avatar sx={{ width: 100, height: 100, background: 'none' }}>
                    <Image
                      src={UnhappyOrtoo}
                      alt="Ortoo"
                      width={100}
                      height={100}
                    />
                  </Avatar>
                }
              />
              <CardContent>
                <Typography variant="body1">
                  Sorry, this page has encountered an unexpected error. If you
                  think this is a mistake, please{' '}
                  <Or2SupportLink>contact us</Or2SupportLink>.
                </Typography>
                <br />
                <Typography variant="body2">
                  <strong>Error:</strong> {error.message}
                </Typography>
                <Typography variant="body2">
                  <strong>Digest:</strong> {error.digest}
                </Typography>
              </CardContent>
              <CardActions>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                  }}
                >
                  <Or2LinkButton href="/">Back to GovernorHub</Or2LinkButton>
                </Box>
              </CardActions>
            </Or2Card>
          </Stack>
        </ThemeRegistry>
      </body>
    </html>
  );
}

export default GlobalError;
